import { IState } from "../..";
import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../../app/store";
import { TerminalTileLoadingStatusState } from "./terminalTilesState";
import TerminaltilesService from "../../../app/data/terminal-summary/terminalTiles/terminalTilesService";

const initialState: TerminalTileLoadingStatusState = {
  loading: false,
  loadingFailed: false,
  loaded: false,
  summary: {
    totalTerminals: 0,
    activeAgents: 0,
    totalAgents: 0,
    regionCount: 0,
    distributorsCount: 0,
    activeDistributors: 0
  },
  // picklists: [],
};

const terminalTilesService = TerminaltilesService.getInstance();

export const terminalTileLoadingStatusSlice = createSlice({
  name: "terminalTileLoadingStatus",
  initialState,
  reducers: {
    resetState: (state) => initialState,
    loadingStarted: (state) => {
      state.loading = true;
      state.loadingFailed = false;
      state.loaded = false;
      state.summary = initialState.summary;
    },
    loadingSucceed: (state, { payload }) => {
      state.loaded = true;
      state.loading = false;
      state.loadingFailed = false;
      state.summary = payload;
    },
    loadingFailed: (state) => {
      state.loading = false;
      state.loadingFailed = true;
      state.summary = initialState.summary;
    }
  }
});

export const {
  resetState,
  loadingStarted,
  loadingSucceed,
  loadingFailed,
} = terminalTileLoadingStatusSlice.actions;

export const terminalTileLoadingStatusSelector = (state: IState) => state.terminalTileLoadingStatus;

export const getTerminalTilesLoadingStatus = (
): AppThunk => async (dispatch) => {
  dispatch(loadingStarted());
  const response = await terminalTilesService.getTerminalTilesPreview();
  if (response.ok() && response.data) {
    dispatch(loadingSucceed(response.data));
  } else {
    dispatch(loadingFailed());
    // let error = "Internal Server Error, re-try the action or contact support";
    dispatch(loadingFailed());
  }
};

const terminalTileLoadingStatusReducer = terminalTileLoadingStatusSlice.reducer;
export default terminalTileLoadingStatusReducer;